const warranty = {

  getOrderForm: function(data){
    var self = this;
    jQuery.ajax({
      type: "POST",
      url: 'warranty/getfullform',
      data: data,
      success: function(html){
        jQuery("#warrantywrapper").html(html);
        self.dropzone = new Dropzone('#photo_dz', {
          url: '/warranty?task=photo',
          acceptedFiles: 'image/*,application/pdf',
          addRemoveLinks: true,
          timeout: 60000,
          parallelUploads: 1
        });
        self.files = {};
        self.photoinput = jQuery('#warrantywrapper input[name=photo]');
        self.dropzone.on('success', function(file, response){
          self.files[file.upload.uuid] = response;
          self.photoinput.val(JSON.stringify(self.files));
          jQuery("#photo_dz").removeClass("field__input_invalid");
        });
        self.dropzone.on('removedfile', function(file){
          if(file.upload.uuid in self.files){
            delete self.files[file.upload.uuid];
          }
          self.photoinput.val(JSON.stringify(self.files));
        });
      }
    });
  },

  saveFullForm: function(data){
    jQuery.ajax({
      type: "POST",
      url: 'warranty/savefullform',
      processData: false,
      contentType: false,
      data: data,
      success: function(html){
        jQuery("#warrantywrapper").html(html);
        jQuery('html, body').animate({
          scrollTop: jQuery("#warrantywrapper").offset().top
        }, 800);
      }
    });
  },

  loadProblemList: function(data){
    jQuery("#problem_list").remove();
    // new problems list
    jQuery.ajax({
      type: "POST",
      url: 'warranty/loadProblemList',
      data: data,
      dataType: 'json',
      success: function(json){
        if(json.identifer != "warranty_problems_selector")
          jQuery("#warranty_problems_selector").remove();

        jQuery("#"+json.identifer).html(json.html);

        if (json.phototitle != "")
          jQuery(".phototitle").text(json.phototitle);
      }
    });
  },

  addProblemBlock: function(item){
    var addHtml = "<div class=\"warranty_problems_item\" id=\"item_"+item+"\" data-in=\""+item+"\"> \
                    <div class=\"problem_close\">&times;</div> \
                    <div class=\"warranty_problems_title\"></div> \
                    <div id=\"warranty_problems_params_"+item+"\"></div> \
                    <div id=\"warranty_problems_selector\"></div> \
                    </div>";
    jQuery("#warranty_problems_list").append(addHtml);
  },

  init: function(){
    jQuery.ajax({
      type: "GET",
      url: 'warranty/getorderform',
      success: function(html){
        jQuery("#warrantywrapper").html(html);
        jQuery('head').append('<link rel="stylesheet" type="text/css" '
            + 'href="/js/dropzone/dropzone.min.css">');
        jQuery.getScript('/js/dropzone/dropzone.min.js')
            .success(function(){ jQuery.getScript('/js/dropzone/dropzone.ru.js'); });
      }
    });

    jQuery("#warrantywrapper").on("submit", "#ordernumberform", function(e){
      var sp = jQuery("input[name=order_number]").val();

      e.preventDefault();
      if (sp != ""){
        warranty.getOrderForm(jQuery(this).serialize());
      }

      return false;
    });

    jQuery("#warrantywrapper").on("submit", "#orderfullform", function(e){
      var data = new FormData(jQuery(this).get(0));

      e.preventDefault();

      // проверим обязательные поля
      var noerror = 1;
      // чекбоксы элементов
      jQuery(".field__input_invalid").removeClass("field__input_invalid");
      if (jQuery("input[name^=elements]").length){
        if (!jQuery("input[name^=elements]:radio:checked").length){
          jQuery(".warranty_product_elements").addClass("field__input_invalid");
          noerror = 0;

          jQuery('html, body').animate({
            scrollTop: (jQuery(".warranty_product_elements").offset().top - 120)
          }, 800);
        }
      }

      // инпуты обязательные
      if (noerror){
        jQuery(".req_field").each(function(){
          if (jQuery(this).val()=="" || jQuery(this).hasClass("notis_show_field")){
            if(this.id === 'problem_list' && jQuery('.warranty_problems_item').length > 1
                && jQuery(this).closest('.warranty_problems_item')
                    .find('.warranty_problems_title').text().trim() === ''){
              return true;
            }
            jQuery(this).addClass("field__input_invalid");
            noerror = 0;

            jQuery('html, body').animate({
              scrollTop: (jQuery(this).offset().top - 120)
            }, 800);

            return false;
          }
        });
      }

      // фотки обязательные
      if (noerror){
        var nofiles = !warranty.files || jQuery.isEmptyObject(warranty.files);

        if (nofiles){
          noerror = 0;

          jQuery("#photo_dz").addClass("field__input_invalid");

          jQuery('html, body').animate({
            scrollTop: (jQuery(".warranty_photos").offset().top - 120)
          }, 800);
        }
      }

      // поля только для ввода цифр и диапозоны
      if (noerror){
        jQuery(".numonly").each(function(){
          if (!jQuery.isNumeric(jQuery(this).val()) || jQuery(this).hasClass("notis_show_field")){
            jQuery(this).addClass("field__input_invalid");
            noerror = 0;

            jQuery('html, body').animate({
              scrollTop: (jQuery(this).offset().top - 120)
            }, 800);

            return false;
          }

          if(jQuery(this).hasClass('numdiap')){
            var param_min = jQuery(this).data('min'),
                param_max = jQuery(this).data('max'),
                param_val = jQuery(this).val();

            if (param_val < param_min || param_val > param_max){
              jQuery(this).addClass("field__input_invalid");
              noerror = 0;

              jQuery('html, body').animate({
                scrollTop: (jQuery(this).offset().top - 120)
              }, 800);

              return false;
            }
          }
        });
      }

      if(!noerror) return;

      // добавим в отправку данные по добавленным проблемам
      jQuery(".warranty_problems_item").each(function(i, el){
        var item = jQuery(el).data("in");
        data.append("problems["+item+"]", jQuery(".warranty_problems_title", el).text());
      });

      warranty.saveFullForm(data);

      return false;
    });

    var imgcount = 4;
    jQuery("#warrantywrapper").on("click", ".addphotos", function(){
      if (imgcount > 12){
        jQuery(".addphotos").remove();
        return;
      }
      for (var i = imgcount; i < imgcount+3; i++) {
        jQuery(".warranty_photos div").append("<input type=\"file\" name=\"photo["+i+"]\" />");
      }
      imgcount += 3;
    });
    // problem list
    var count_selector = 1;
    jQuery("#warrantywrapper").on("change", "#problem_list", function(){
      var data = {},
          el = jQuery(this).closest(".warranty_problems_item"),
          elText = jQuery(".warranty_problems_title", el).text();

      if (elText != "") elText = elText + " - ";
      jQuery(".warranty_problems_title", el).text(elText + jQuery("#problem_list option:selected").text());

      ++count_selector;
      data.pid = jQuery(this).val();
      data.cc = count_selector;
      data.in = el.data('in');

      warranty.loadProblemList(data);
    });


    jQuery("#warrantywrapper").on("click", "#warranty_problems_add", function(){
      var el = jQuery(this).closest(".warranty_problems_item"),
          addHtml = "",
          item = (el.data('in') + 1),
          data = {};

      jQuery("#warranty_problems_add, #warranty_problems_selector").remove();

      warranty.addProblemBlock(item);

      count_selector = 1;
      data.pid = 0;
      data.cc = count_selector;

      warranty.loadProblemList(data);
    });

    jQuery("#warrantywrapper").on("click", ".problem_close", function(){
      var el = jQuery(this).closest(".warranty_problems_item"),
          item = el.data('in'),
          data = {},
          listLength = jQuery("#problem_list, #warranty_problems_add", el).length;
      ;

      if(listLength){
        jQuery("#item_"+item).remove();

        warranty.addProblemBlock(item);

        count_selector = 1;
        data.pid = 0;
        data.cc = count_selector;

        warranty.loadProblemList(data);
      }else{
        jQuery("#item_"+item).remove();
      }

    });

    jQuery("#warrantywrapper").on("click", ".warranty_params_clone", function(){
      var item = jQuery(this).attr("rel"),
          html_params = jQuery(".param_item_"+item).html(),
          new_block;

      jQuery(this).before("<div class='border-top-1' style='margin-top:20px'>"+html_params+"</div>");
      new_block = jQuery(this).prev();

      jQuery("input", new_block).val("");
      jQuery("textarea", new_block).text("");
    });
    // \problem list

  }
};

export default warranty;